/** @jsxImportSource theme-ui */
import { Box, Text } from "@bottlebooks/gatsby-design-system";
import { Trans } from "@lingui/macro";
import { FragmentType, graphql, useFragment } from "~/gql";

const fragment = graphql(`
  fragment BottleVariant on ProductBottleVariant {
    GTIN
    bottleSize
    bottleNetWeight
    closureType
  }
`);
export default function BottleVariant({
  data,
  ...rest
}: {
  data: FragmentType<typeof fragment>;
}) {
  const bottleVariant = useFragment(fragment, data);
  if (!hasContent(data)) return null;

  return (
    <Box {...rest}>
      {bottleVariant.bottleSize ? (
        <Value title={<Trans comment="Bottle size">Size</Trans>}>
          {bottleVariant.bottleSize}
        </Value>
      ) : null}
      {bottleVariant.bottleNetWeight ? (
        <Value title={<Trans>Weight</Trans>}>
          {bottleVariant.bottleNetWeight}g
        </Value>
      ) : null}
      {bottleVariant.GTIN ? (
        <Value title={<Trans>GTIN</Trans>}>{bottleVariant.GTIN}</Value>
      ) : null}
      {bottleVariant.closureType ? (
        <Value title={<Trans>Closure</Trans>}>
          {bottleVariant.closureType}
        </Value>
      ) : null}
    </Box>
  );
}
function hasContent(data: FragmentType<typeof fragment>) {
  const bottleVariant = useFragment(fragment, data);
  if (!bottleVariant) return false;
  if (bottleVariant.GTIN) return true;
  if (bottleVariant.bottleSize) return true;
  if (bottleVariant.closureType) return true;
  if (bottleVariant.bottleNetWeight) return true;
  return false;
}
BottleVariant.hasContent = hasContent;
/**
 * This picks the fields from the variant that are actually used in this component.
 * We can use this in the parent component to determine the unique values.
 * @param {object} variant
 * @param {string?} variant.GTIN
 * @param {string?} variant.bottleSize
 * @returns
 */
BottleVariant.getContent = ({ GTIN, bottleSize }) => ({ GTIN, bottleSize });

function Value({ title, children, ...rest }) {
  if (!children) return null;
  return (
    <Text {...rest}>
      {title}: {children}
    </Text>
  );
}
